/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
export type SbRespRefineMenuFilterDeliveryOptions_itemSearch$ref = any;
export type SbRespRefineMenuFilterDeliveryOptions_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuFilterDeliveryOptions_itemSearch$ref;
    readonly " $refType": SbRespRefineMenuFilterDeliveryOptions_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuFilterDeliveryOptions_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilterDeliveryOptions_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = '8b6bce311e661d4c02077b889d5a2642';
export default node;
